import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { BusinessHeader, BusinessFooter } from "./BusinessHome";
import { Check, Calendar } from "lucide-react";

export default function BusinessDemoConfirmed() {
  const [p] = useSearchParams();
  const slot = p.get("slot");
  const date = p.get("date");
  return (
    <div className="min-h-screen">
      <BusinessHeader />
      <div className="max-w-lg mx-auto px-4 py-14 text-center">
        <div className="w-16 h-16 mx-auto rounded-full bg-green-100 text-green-600 grid place-items-center">
          <Check size={28} />
        </div>
        <h1 className="font-heading text-3xl font-bold text-brand-dark mt-3">Demo booked 🎉</h1>
        <p className="text-brand-dark/60 mt-2">Our team will call/WhatsApp to confirm within a few hours.</p>
        {slot && (
          <div className="mt-5 bg-white rounded-2xl border border-brand-dark/5 p-4">
            <div className="text-xs text-brand-dark/60 uppercase tracking-widest">Your slot</div>
            <div className="font-heading font-semibold text-brand-dark mt-1">
              {date} · {slot}
            </div>
          </div>
        )}
        <div className="mt-5 flex gap-2 justify-center">
          <a
            href={`data:text/calendar;charset=utf8,BEGIN:VCALENDAR%0AVERSION:2.0%0ABEGIN:VEVENT%0ASUMMARY:Tabdine%20Demo%0ADESCRIPTION:Tabdine%20product%20walkthrough%0AEND:VEVENT%0AEND:VCALENDAR`}
            download="tabdine-demo.ics"
            className="inline-flex items-center gap-1 border-2 border-brand-dark text-brand-dark px-4 py-2 rounded-full text-sm"
            data-testid="add-to-calendar"
          >
            <Calendar size={14} /> Add to Calendar
          </a>
          <Link to="/business" className="bg-brand-orange text-white px-4 py-2 rounded-full text-sm">
            Back to home
          </Link>
        </div>
      </div>
      <BusinessFooter />
    </div>
  );
}
